import * as actionTypes from './userActionTypes';

export const login = (username, userid, roles) => ({type: actionTypes.LOGIN, username:username, userid:userid, roles:roles});
export const logout = () => ({type: actionTypes.LOGOUT});

export const setLogin = (loginstate) => {
    return {
        type: actionTypes.SET_LOGIN,
        payload: loginstate
    };
};

export const setUserid = (userId) => {
    return {
        type: actionTypes.SET_USERID,
        payload: userId
    };
};
